<template>
    <v-container fluid class="b-container">
        <v-row no-gutters justify="center" class="fill-height">
            <v-col cols="8">
                <v-card
                    color="#f5f5fd"
                    class="rounded-tl-lg rounded-tr-lg pt-12"
                    style="padding-bottom: 120px"
                    tile
                    flat
                    dark
                >
                    <v-card-title class="justify-center text-black text-h5">{{
                        title[lang]
                    }}</v-card-title>
                </v-card>

                <v-row no-gutters justify="center" class="px-12">
                    <v-col
                        v-for="provider in appProviders"
                        :key="provider.app_provider_id"
                        cols="4"
                        class="b-floating"
                    >
                        <v-card class="pa-4">
                            <div
                                class="
                                    text-button
                                    font-weight-bold
                                    blue--text
                                    text--darken-2 text-center
                                "
                                v-text="provider.title"
                            ></div>
                            <div class="d-flex justify-center mt-2">
                                <div class="card-img">
                                    <v-img
                                        max-height="100"
                                        max-width="150"
                                        :src="provider.image"
                                    ></v-img>
                                </div>
                            </div>

                            <!-- <div class="text-center mt-2">
                                <span class="text-h5 font-weight-bold">5%</span>
                                <span
                                    class="font-weight-medium ml-1 text--secondary"
                                    >/ month</span
                                >
                            </div> -->

                            <v-divider class="mt-3"></v-divider>

                            <v-btn
                                color="blue darken-2"
                                class="b-btn"
                                outlined
                                block
                                style="font-size: 0.8rem; letter-spacing: 0.5px"
                                @click="setAppProvider(provider)"
                                >{{ buttonText[lang] }}</v-btn
                            >
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mdiFileDocumentEditOutline, mdiCheckCircleOutline } from "@mdi/js";
import { mapActions } from "vuex";

export default {
    name: "AppProviders",

    data: () => ({
        icons: { mdiFileDocumentEditOutline, mdiCheckCircleOutline },
        title: {
            el: "Eπίλεξε τον πάροχο:",
            en: "Select the provider you want:",
            it: "Seleziona il fornitore:",
        },
        buttonText: {
            el: "Eπιλογή",
            en: "Select",
            it: "Seleziona",
        },
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        appProviders() {
            return this.$store.state.register.appProviders;
        },
    },

    methods: {
        ...mapActions("register", ["getAppProviders"]),

        setAppProvider(provider) {
            localStorage.setItem("appProvider", provider.app_provider_id);
            localStorage.setItem("providerStoreId", provider.store_id);
            const registrationType = localStorage.getItem("registerPage");
            this.$router.push(`/${this.lang}/subscription-plans`);
        },
    },

    mounted() {
        this.getAppProviders();
    },
};
</script>

<style scoped>
.b-container {
    height: 100%;
    padding: 0;
    background: #f5f5fd;
}

.b-floating {
    padding: 0 15px;
    transform: translateY(-28%);
}

.b-btn:hover {
    background-color: #1976d2 !important;
    color: white !important;
}

.card-img {
    height: 100px;
    width: 150;
}

.text-black {
    color: black;
}
</style>
